import {
  Backdrop,
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
} from '@mui/material';

interface FullscreenLoaderProps {
  /**
   * Whether or not the fullscreen loader is being
   * currently displayed.
   */
  open: boolean;
  /**
   * The text to display in the Loader card header.
   * @default 'Loading'
   */
  headerText?: string;
}

export const FullscreenLoader = ({
  open,
  headerText = 'Loading',
}: FullscreenLoaderProps) => {
  return (
    <Backdrop
      component="div"
      aria-label="Fullscreen loader"
      open={open}
      sx={{ zIndex: 10000 }}
    >
      <Card sx={{ width: '300px' }}>
        <CardHeader
          title={headerText}
          sx={{
            textAlign: 'center',
            '& .MuiTypography-root': {
              fontWeight: 500,
            },
          }}
        />
        <CardContent
          sx={{
            display: 'grid',
            placeItems: 'center',
            padding: '0 24px 16px',
            height: '84px',
          }}
        >
          <CircularProgress thickness={3.5} size={52} />
        </CardContent>
      </Card>
    </Backdrop>
  );
};
